import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { toNetTime }                from './../common/functions';
import { GridInterfaceService }     from './grid.interface.service';
import { CommonService }            from './common.service';
import { PdfInterfaceService }      from './pdf.interface.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class PeakService implements GridInterfaceService, PdfInterfaceService {

   private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'peak', snackbar);
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.getItems(filter);
    }

    public getPeakValues(): Observable<any> {
        return this._commonService.get('peakValues');
    }

    public insertItem(item: any): Observable<any> {
        let model = {
            PeakDate: toNetTime(item.date),
            PeakID: item.peakID,
            TrainUid: item.trainUid
        };
        return this._commonService.insertItem(model);
    }

    public copy(sourceModel: any, targetModel: any): Observable<any> {
        let model = {
            SourceModel : sourceModel,
            TargetModel: targetModel
        };
        return this._commonService.post('copy', model);
    }

    public updateItem(id: string, item: any): Observable<any> {
       return this._commonService.updateItem(id, item);
    }

    public deleteItem(id: string): Observable<any> {
        return this._commonService.deleteItem(id);
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public pdfUrl(filter: ISortableFilter, columnParams: Array<any>): string {
        return this._commonService.pdfUrl(filter, columnParams);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/peak.service.ts